import AuthService from "../../../services/AuthService";
import pdfHandler from "../../shared/utils/pdfHandler";
import moment from "../../shared/utils/moment_fr";

export default class SalarieService {
    constructor() {
        this.Auth = new AuthService();
    }

    downloadOpenedEntretien(id_entretien) {
        this.Auth.fetch(`/services/pdf/entretien/${id_entretien}?is_apercu=true`, {responseType: 'arraybuffer'})
            .then(x => pdfHandler(x.data, 'aperçu_entretien'));
    }

    downloadSignedentretien(id_entretien) {
        this.Auth.fetch(`/services/pdf/entretien/${id_entretien}`, {responseType: 'arraybuffer'})
            .then(x => pdfHandler(x.data, 'entretien_professionnel'));
    }

    editSalarieInfos(data) {
        return this.Auth.fetch('/salarie/infos', {method: 'PUT', data: data});
    }

    acceptEntretien(data) {
        return this.Auth.fetch('/salarie/entretien/accept', {method: 'POST', data: data});
    }

    demandeEntretien(data) {
        return this.Auth.fetch('/societe/entretien',
            {
                method: 'post',
                data: {
                    date_heure: moment(data.day).hours(data.hour).minutes(data.minute).unix(),
                    id_salarie: data.id_salarie
                }
            });
    }

    candidaterPosteInterne(id_offre) {
        return this.Auth.fetch('/salarie/poste/candidate/' + id_offre, {method: 'PUT'});
    }

    annulerCandidaturePoste(id_candidature) {
        return this.Auth.fetch('/salarie/poste/candidature/' + id_candidature, {method: 'DELETE'});
    }

    getCandidatureBySalarie() {
        return this.Auth.fetch('/salarie/postes/candidatures');
    }
}


// WEBPACK FOOTER //
// ./src/components/salarie/services/SalarieService.js